import { Component, OnInit, Input } from "@angular/core";
import { FlujoVentaPaso } from "../../../_models/flujo-venta-paso";
import { TabViewCustom } from "../../../_models/tab-view-custom";
import { SelectItem } from "primeng/api";

@Component({
  selector: "app-flujo-venta-respaldos",
  templateUrl: "./flujo-venta-respaldos.component.html",
  styleUrls: ["./flujo-venta-respaldos.component.css"],
})
export class FlujoVentaRespaldosComponent implements OnInit {
  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() titulo: string;

  tabSeleccionado = "DATGEN";

  constructor() {}

  ngOnInit() {}

  abrirAcordeon(evento: number) {
    switch (evento) {
      case 0: {
        this.tabSeleccionado = "DATGEN";
        break;
      }
      case 1: {
        this.tabSeleccionado = "RESPERXVIN";
        break;
      }
    }
  }
}
